import { useEffect, useState } from "react";
import { API } from "@/lib/site";

let cache = null;
let pending = null;

export function useBanners() {
  const [list, setList] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || fetch(`${API}/banners/active`).then((r) => r.json()).catch(() => []);
    pending.then((d) => { cache = Array.isArray(d) ? d : []; setList(cache); });
  }, []);
  return list || [];
}

const BACKEND = API.replace(/\/api$/, "");

export const DirectBanner = ({ banner, id }) => (
  <a href={banner.link} target="_blank" rel="sponsored noopener noreferrer" data-testid={`direct-banner-${id}`} className="block mx-auto w-fit max-w-full">
    <img src={`${BACKEND}${banner.image}`} alt={banner.alt} loading="lazy" width={banner.width || undefined} height={banner.height || undefined}
      className="block h-auto max-w-full rounded-md" />
  </a>
);
